export const messages = [
  {
    key: "VALENTINE_MESSAGE",
    content: {
      image:
        "https://cloud.toddleapp.com/assets/illustrations/lovenotesforteacher.png",
      text: `
        Dear Parent,<br />
        <p>
          The last two years have been hard on all of us - especially teachers. Through these trying times, teachers have had their smiles on and kept learning going. 
          This Valentine’s Day, we’d like to celebrate teachers around the world for their grace and grit.  And to do that we need your support 💝 <br />
        </p>
        <p>
          Here is what we’ll need you to do:
        </p>
        <p>
          1. Get your child to create a written or video note thanking their teacher(s). You can be a part of it, too! <br />
          2. Click below to share the note with us by Thursday, 10th Feb, 2022 <br />
        </p>
        <p>
          We’ll publish these #LoveNotesforTeachers on social media on Valentine's Day and tag your teachers. <br />
        </p>
        <p>
          Can’t wait to make this a ‘note’worthy Valentines for teachers!  <br />
        </p>
        <p>
          Warmly, <br />
          Team Toddle  <br />
        </p>
      `,
      title: "Let's send our thanks to teachers!",
      button: {
        text: "Share your note",
        url: "https://forms.gle/Rrheie2eJnZFRcMR7",
      },
    },
  },
];
